import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'anchor';
		id: string;
		properties: { anchorName: string };
	};
}

export const mapAnchor = async ({ content }: Props): Promise<Content.Anchor> => {
	try {
		return {
			documentType: content?.contentType || null,
			content: {
				properties: {
					anchorName: content.properties?.anchorName || null,
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map Anchor \nCause: ${e}`);
		throw new Error(`Could not map Anchor \nCause: ${e}`, e);
	}
};
